// Spread onto a primary-action Button (New loan, Save, etc.) instead of the
// `primary` boolean prop. The theme-level `button.primary.background`
// override (funderAllocationTheme.js) wasn't actually landing on the
// rendered button for reasons that weren't worth chasing further inside
// Grommet's internal theme merge pipeline - `background`/`hoverIndicator`
// are plain, directly-documented Button props with no "kind" resolution
// in between, so this is the version that's guaranteed to render correctly.
const ctaButtonProps = {
    background: "cta",
    hoverIndicator: "cta-hover",
};

export { ctaButtonProps };
